import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {salidaStore} from "@/store/salidaStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class SalidaService{
    private static instance: SalidaService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    salidaStore = salidaStore();
    globalStore = globalStore();


    makePagination(page: any) {
        this.salidaStore.pagination.per_page = page.per_page;
        this.salidaStore.pagination.current_page = page.current_page;
        this.salidaStore.pagination.last_page = page.last_page;
    }


    public async index(data: any) {
        this.salidaStore.loading = true;
        await http.get("getSalidas", {params: data}).subscribe({
            next: (response) => {
                this.salidaStore.salidas = response.data.data;
                this.makePagination(response.data);
                this.salidaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async indexCompraMateriales(data: any) {
        this.salidaStore.loading = true;
        await http.get("getCompraMateriales", {params: data}).subscribe({
            next: (response) => {
                this.salidaStore.valeSalidas = response.data.data;
                this.makePagination(response.data);
                this.salidaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async indexValeSalidas(data: any) {
        this.salidaStore.loading = true;
        await http.get("getValeSalidas", {params: data}).subscribe({
            next: (response) => {
                this.salidaStore.valeSalidas = response.data.data;
                this.makePagination(response.data);
                this.salidaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async indexPrestamoMaterial(data: any) {
        this.salidaStore.loading = true;
        await http.get("getPrestamoMaterial", {params: data}).subscribe({
            next: (response) => {
                this.salidaStore.prestamosMaterial = response.data.data;
                this.makePagination(response.data);
                this.salidaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async indexValeGasolina(data: any) {
        this.salidaStore.loading = true;
        await http.get("getValeGasolina", {params: data}).subscribe({
            next: (response) => {
                this.salidaStore.valeSalidas = response.data.data;
                this.makePagination(response.data);
                this.salidaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }


    public async getNuevoCodigo() {
        await http.get("nuevo-codigo-salida").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.nuevoCodigo = response.data
                }
            }
        })
    }

    public async getNuevoCodigoVale() {
        await http.get("nuevo-codigo-salida-vale").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.nuevoCodigoVale = response.data
                }
            }
        })
    }

    public async getNuevoCodigoCompra() {
        await http.get("nuevo-codigo-compra").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.nuevoCodigoCompraMateriales = response.data
                }
            }
        })
    }

    public async getNuevoCodigoPrestamo() {
        await http.get("nuevo-codigo-prestamo").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.nuevoCodigoPrestamo = response.data
                }
            }
        })
    }

    public async getNuevoCodigoValeGasolina() {
        await http.get("obtenerUltimoCodigoGasolinae").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.nuevoCodigoValeGasolina = response.data
                }
            }
        })
    }

    public async getFuncionarioResponsable() {
        await http.get("getAutoriza").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.funcionario_responsable = response.data;
            },
        })
    }

    public async getChoferResponsable() {
        await http.get("getChoferes").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.chofer_responsable = response.data;
            },
        })
    }

    public async getEstacionServicio() {
        await http.get("getEstacionServicio").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.estacionServicio = response.data;
            },
        })
    }

    public async getMovilidades() {
        await http.get("getMovilidad").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.movilidades = response.data;
            },
        })
    }

    public async getCentroCostos() {
        await http.get("getCentroCostos").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.centroCostos = response.data;
            },
        })
    }

    public async obtenerCentroCosto(data: any) {
        await http.get("obtenerCentroCostos", {params: data}).subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.centroCostoFuncionario = response.data;
            },
        })
    }

    public async getLitros() {
        await http.get("getLitos").subscribe({
            next: (response:AxiosResponse) => {
                this.salidaStore.litros = response.data;
            },
        })
    }


    public async saveSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Salida de Almacenes registrado correctamente");
                        this.salidaStore.salida = response.data.salida
                        this.salidaStore.newSalida = response.data.salida
                        this.salidaStore.salidasMaterial = response.data.materialesSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async updateSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("updateSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Salida actualizada correctamente");
                        this.salidaStore.salida = response.data.salida
                        this.salidaStore.newSalida = response.data.salida
                        this.salidaStore.salidasMaterial = response.data.materialesSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async getPresupuesto(data: any) {
        this.salidaStore.loading = true;
        await http.get("getPresupuesto", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.salidaStore.presupuesto = response.data.presupuesto;
                    this.salidaStore.tipoInstalacion = response.data.tipoInstalacion;
                    this.salidaStore.cantidadValeGasolina = response.data.cantidad;
                    this.salidaStore.funcionarioAutoriza = response.data.funcionarioAutoriza;
                    this.salidaStore.cantidadVales = response.data.cantidadVales;
                    this.salidaStore.loading = false;
                } else {
                    Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                    this.salidaStore.presupuesto = [];
                }

            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async showMaterialesSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("showMaterialesSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.salidaStore.salidasMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async showMaterialesPrestamo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("showMaterialesPrestamo", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async finalizarSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("finalizarSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Salida Finalizada correctamente");
                        this.salidaStore.salida = response.data.salida
                        this.salidaStore.newSalida = response.data.salida
                    }else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }

                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async confirmarSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("confirmarSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Salida confirmado correctamente");
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }


                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async devolverMateriales(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("devolverMateriales", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Materiales devueltos correctamente");
                        this.salidaStore.salida = response.data.salida
                        this.salidaStore.newSalida = response.data.salida
                        this.salidaStore.salidasMaterial = response.data.materialesSalida
                    }else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }

                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async saveMedidor(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveMedidor", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Medidor guardado correctamente");
                    }else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }

                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async updateQuantitySalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("updateQuantitySalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Cantidad actualizada correctamente");
                        this.salidaStore.salidasMaterial = response.data.materialesSalida
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getVehiculos(txtSearch: string) {
        this.salidaStore.loading = true;
        const data = {txtSearch: txtSearch}
        await http.get("getMovilidad", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.movilidades = response.data
                    this.salidaStore.loading = false;
                }
            },error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async deleteMaterialValeSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialValeSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material eliminado del ingreso correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialCompra(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialCompra", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material eliminado del ingreso correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialPlancha(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialPlancha", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material eliminado de la plancha");
                        this.salidaStore.planchaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialPrestamo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialPrestamo", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material eliminado del ingreso correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialesValeSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialesValeSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.salidaStore.valeSalidaMaterial = [];
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialesCompra(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialesCompra", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.salidaStore.valeSalidaMaterial = [];
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialesPlancha(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialesPlancha", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.salidaStore.planchaMaterial = [];
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialesPrestamo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("deleteMaterialesPrestamo", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.salidaStore.valeSalidaMaterial = [];
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getPlancha() {
        this.salidaStore.loading = true;
        await http.post("getPlancha").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.planchaMaterial = response.data
                    this.salidaStore.loading = false;
                }
            },error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async getFuncionarios(txtSearch: string) {
        this.salidaStore.loading = true;
        const data = {txtSearch: txtSearch}
        await http.get("indexFuncionario", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.funcionarios = response.data
                    this.salidaStore.loading = false;
                }
            },error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }

    public async getMedidores(txtSearch: string) {
        this.salidaStore.loading = true;
        const data = {txtSearch: txtSearch}
        await http.get("getMedidores", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.salidaStore.medidores = response.data
                    this.salidaStore.loading = false;
                }
            },error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.salidaStore.loading = false;
            }
        })
    }


    public async saveValeSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveValeSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Vale de Salida registrado correctamente");
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async saveCompraMateriales(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveCompraMateriales", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Vale de Salida registrado correctamente");
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async savePrestamoMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("savePrestamoMaterial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Prestamo de material registrado correctamente");
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async saveNumeroPresupuesto(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveNumeroPresupuesto", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Prestamo de material registrado correctamente");
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async updateValeSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("updateValeSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Vale de Salida actualizado correctamente");
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async updatePrestamoMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("updatePrestamoMaterial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Prestamo de material actualizado correctamente");
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async saveValeGasolina(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("saveValeGasolina", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Vale de Gasolina registrado correctamente");
                        this.salidaStore.valeGasolina = response.data.valeGasolina
                        this.salidaStore.newValeGasolina = response.data.valeGasolina
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }



    public async updateValeGasolina(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("updateValeGasolina", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Vale de Gasolina actualizado correctamente");
                        this.salidaStore.valeGasolina = response.data.valeGasolina
                        this.salidaStore.newValeGasolina = response.data.valeGasolina
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialValeSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialValeSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado al vale de salida correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialCompraMateriales(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialCompraMateriales", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado al vale de salida correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialManual(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialManual", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado al vale de salida correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialPlancha(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialPlancha", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado a la plancha");
                        this.salidaStore.planchaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialSalida(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialSalida", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado a la salida correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async addMaterialPrestamo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("addMaterialPrestamo", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado al vale de salida correctamente");
                        this.salidaStore.valeSalidaMaterial = response.data
                        this.salidaStore.loading = false;
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async imprimirValeSalida(id:number) {

        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.get(`finalizarValeSalida/${id}`).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida

                         http.get(`imprimirValeSalida/${id}`).subscribe({
                            next: (response:AxiosResponse) => {
                                window.open(
                                    `${this.baseURL}imprimirValeSalida/${id}`, "_blank");
                            },
                        })

                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async imprimirCompraMateriales(id:number) {

        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.get(`finalizarCompraMateriales/${id}`).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida

                        http.get(`imprimirCompraMateriales/${id}`).subscribe({
                            next: (response:AxiosResponse) => {
                                window.open(
                                    `${this.baseURL}imprimirCompraMateriales/${id}`, "_blank");
                            },
                        })

                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async imprimirPrestamoMaterial(id:number) {

        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.get(`finalizarValeSalida/${id}`).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        this.salidaStore.valeSalida = response.data.valeSalida
                        this.salidaStore.newValeSalida = response.data.valeSalida

                        http.get(`imprimirPrestamoMaterial/${id}`).subscribe({
                            next: (response:AxiosResponse) => {
                                window.open(
                                    `${this.baseURL}imprimirPrestamoMaterial/${id}`, "_blank");
                            },
                        })

                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }
    public async imprimirPrestamoMaterialSinFinalizar(id:number) {
        await http.get(`imprimirPrestamoMaterial/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                if (response.data.success === false){
                    Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                }else {
                    window.open(
                        `${this.baseURL}imprimirPrestamoMaterial/${id}`, "_blank");
                }
            },
        })
    }

    public async imprimirMedidor(id:number) {
        await http.get(`imprimirMedidor/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                if (response.data.success === false){
                    Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                }else {
                window.open(
                    `${this.baseURL}imprimirMedidor/${id}`, "_blank");
                }
            },
        })
    }

    public async imprimirValeGasolina(id:number) {

        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.get(`finalizarValeGasolina/${id}`).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        this.salidaStore.valeGasolina = response.data.valeGasolina
                        this.salidaStore.newValeGasolina = response.data.valeGasolina

                        http.get(`imprimirValeGasolina/${id}`).subscribe({
                            next: (response:AxiosResponse) => {
                                window.open(
                                    `${this.baseURL}imprimirValeGasolina/${id}`, "_blank");
                            },
                        })

                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async historial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("historial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.historial = response.data.historial
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async adjuntarDocumento(codigo:string, formData: any, headers:any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("cargarDocumento/" + codigo, formData, headers).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr(`<h1>${response.data.message}</h1>`);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async adjuntarImagenValeGasolina(data:any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.salidaStore.loading = true;
            http.post("adjuntarImagenValeGasolina", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.salidaStore.loading = false;
                    if (response.data.success) {
                        this.salidaStore.newValeGasolina = response.data.valeGasolina
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.salidaStore.loading = false;
                    reject(error);
                }
            })
        });
    }
}